import { render, staticRenderFns } from "./PriceForm.vue?vue&type=template&id=66c30a8a&scoped=true"
import script from "./PriceForm.vue?vue&type=script&lang=js"
export * from "./PriceForm.vue?vue&type=script&lang=js"
import style0 from "./PriceForm.vue?vue&type=style&index=0&id=66c30a8a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66c30a8a",
  null
  
)

export default component.exports